/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notif_Push_OnInputs */

const vi_notif_push_on = /** @type {(inputs: Notif_Push_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bật đẩy`)
};

/**

* @param {Notif_Push_OnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const notif_push_on = /** @type {((inputs?: Notif_Push_OnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_Push_OnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notif_push_on(inputs)
});